import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["report", "onChange"];
import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { List as ImmutableList } from 'immutable';
import { useCallback, useMemo } from 'react';
import { ASC, DESC } from 'reporting-data/constants/sortOrder';
import { getDataType, getDimensions, getSort } from 'reporting-data/report/configReportGetters';
import { setSort } from 'reporting-data/report/configReportSetters';
import { isExternalEnumerationWithDisplayOrder } from 'reporting-data/retrieve/inboundDb/common/dataTypes';
import { getIsDisplayOrderSort, getSortOrder, getSortPropertyValueFromConfigReport } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const getSortDirectionOptions = report => {
  const dimensions = getDimensions(report);
  const property = getSortPropertyValueFromConfigReport(report);
  if (dimensions.includes(property)) {
    const displayOrderOptions = [{
      value: `.displayOrder|${ASC}`,
      text: I18n.text('report-customization-components.customization-components.sort-selector-dropdown.config.options.sortDisplayOrder')
    }, {
      value: `.displayOrder|${DESC}`,
      text: I18n.text('report-customization-components.customization-components.sort-selector-dropdown.config.options.sortReverseDisplayOrder')
    }];
    if (isExternalEnumerationWithDisplayOrder(getDataType(report), property)) {
      return displayOrderOptions;
    } else {
      return [{
        value: `ALPHA|${ASC}`,
        text: I18n.text('report-customization-components.customization-components.sort-selector-dropdown.config.options.sortAlphabetically')
      }, {
        value: `ALPHA|${DESC}`,
        text: I18n.text('report-customization-components.customization-components.sort-selector-dropdown.config.options.sortReverseAlphabetically')
      }, ...displayOrderOptions];
    }
  } else {
    return [{
      value: DESC,
      text: I18n.text('report-customization-components.customization-components.sort-selector-dropdown.config.options.sortDescending')
    }, {
      value: ASC,
      text: I18n.text('report-customization-components.customization-components.sort-selector-dropdown.config.options.sortAscending')
    }];
  }
};
const ConfigReportSortDirectionDropdown = props => {
  const {
      report,
      onChange
    } = props,
    selectProps = _objectWithoutPropertiesLoose(props, _excluded);
  const dropdownOptions = useMemo(() => {
    return getSortDirectionOptions(report);
  }, [report]);
  const valueForDropdown = useMemo(() => {
    const sortProperty = getSortPropertyValueFromConfigReport(report);
    const dimensions = getDimensions(report);
    const isDisplaySort = getIsDisplayOrderSort(report);
    const valuePrefix = dimensions.includes(sortProperty) ? `${isDisplaySort ? '.displayOrder' : 'ALPHA'}|` : '';
    const sortOrder = getSortOrder(report);
    return `${valuePrefix}${sortOrder}`;
  }, [report]);
  const onSortDirectionChange = useCallback(({
    target: {
      value
    }
  }) => {
    var _getSort;
    const sort = (_getSort = getSort(report)) === null || _getSort === void 0 ? void 0 : _getSort.first();
    const sortProperty = getSortPropertyValueFromConfigReport(report);
    const dimensions = getDimensions(report);
    let newSort;
    if (dimensions.includes(sortProperty)) {
      const [sortType, order] = value.split('|');
      if (sortType === '.displayOrder') {
        newSort = sort.set('property', `${sortProperty}${sortType}`).set('type', 'METRIC').set('metricType', 'MAX');
      } else {
        newSort = sort.set('property', `${sortProperty}`).set('type', 'ALPHA').delete('metricType');
      }
      newSort = newSort.set('order', order);
    } else {
      newSort = sort.set('order', value);
    }
    onChange(setSort(report, ImmutableList([newSort])));
  }, [report, onChange]);
  return /*#__PURE__*/_jsx(FormControl, {
    children: /*#__PURE__*/_jsx(Select, Object.assign({}, selectProps, {
      onChange: onSortDirectionChange,
      options: dropdownOptions,
      value: valueForDropdown
    }))
  });
};
export default ConfigReportSortDirectionDropdown;